import { forwardRef } from "react";
import { Box } from "./Box";
import { jsx } from "react/jsx-runtime";
const Row = forwardRef(function(props, ref) {
  return /* @__PURE__ */ jsx(Box, { ref, flexDirection: "row", ...props });
});
export {
  Row
};
